import type {
  TFileLibraryQueryInput,
  TFileLibrarySort,
  TFileLibraryTimeRange,
  TFileLibraryUploadType,
} from '../types';

/** 列表每页条数，与接口 page_size 一致 */
export const FILE_LIBRARY_PAGE_SIZE = 20;

/** 默认按创建时间倒序 */
export const DEFAULT_FILE_LIBRARY_SORT: TFileLibrarySort = {
  key: 'created_at',
  asc: false,
};

/** 查询默认值：切换页签时整体重置回该状态（uploadType 随当前页签派生） */
export const INIT_FILE_LIBRARY_QUERY: TFileLibraryQueryInput = {
  keyword: '',
  fileType: '',
  timeRange: '',
  source: null,
  sort: DEFAULT_FILE_LIBRARY_SORT,
};

/** 页面 Tab，id 即 upload_type */
export const FILE_LIBRARY_PAGE_TABS: {
  id: TFileLibraryUploadType;
  labelId: string;
}[] = [
  { id: 'all', labelId: 'dba_file_library_tab_all' },
  { id: 'brainy', labelId: 'dba_file_library_tab_brainy' },
  { id: 'user', labelId: 'dba_file_library_tab_user' },
];

/** 来源下拉内部 Tab */
export const FILE_LIBRARY_SOURCE_TABS: {
  id: 'agent' | 'skill';
  labelId: string;
}[] = [
  { id: 'agent', labelId: 'dba_file_library_source_agent' },
  { id: 'skill', labelId: 'dba_file_library_source_skill' },
];

/** 文件类型：筛选项 value、i18n、标签 modifier / 展示文案 */
export const FILE_TYPE_OPTIONS: {
  value: string;
  labelId: string;
  modifier: string;
  tagLabel: string;
}[] = [
  {
    value: 'pdf',
    labelId: 'dba_file_library_type_pdf',
    modifier: 'pdf',
    tagLabel: 'PDF',
  },
  {
    value: 'ppt',
    labelId: 'dba_file_library_type_ppt',
    modifier: 'ppt',
    tagLabel: 'PPT',
  },
  {
    value: 'word',
    labelId: 'dba_file_library_type_word',
    modifier: 'word',
    tagLabel: 'Word',
  },
  {
    value: 'excel',
    labelId: 'dba_file_library_type_excel',
    modifier: 'excel',
    tagLabel: 'Excel',
  },
  {
    value: 'csv',
    labelId: 'dba_file_library_type_csv',
    modifier: 'csv',
    tagLabel: 'CSV',
  },
  {
    value: 'html',
    labelId: 'dba_file_library_type_html',
    modifier: 'html',
    tagLabel: 'HTML',
  },
  {
    value: 'md',
    labelId: 'dba_file_library_type_md',
    modifier: 'md',
    tagLabel: 'Markdown',
  },
  {
    value: 'txt',
    labelId: 'dba_file_library_type_txt',
    modifier: 'txt',
    tagLabel: 'TXT',
  },
  {
    value: 'zip',
    labelId: 'dba_file_library_type_zip',
    modifier: 'zip',
    tagLabel: 'ZIP',
  },
  {
    value: 'image',
    labelId: 'dba_file_library_type_image',
    modifier: 'image',
    tagLabel: 'Image',
  },
];

/** 时间快捷筛选项 */
export const TIME_RANGE_OPTIONS: {
  value: TFileLibraryTimeRange;
  labelId: string;
}[] = [
  { value: 'today', labelId: 'dba_file_library_time_today' },
  { value: '7d', labelId: 'dba_file_library_time_7d' },
  { value: '30d', labelId: 'dba_file_library_time_30d' },
];
